<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Address
            </h2>
            <v-form name="editForm" ref="editForm">
                <v-select
                    v-model="modelObject.type"
                    :items="addressTypeValueList"
                    color="primary"
                    label="Type"
                    display-label="Type"
                    :rules="[rules.required]"
                    reactive
                />
                <div class="tw-flex tw-flex-row tw-gap-2">
                    <v-text-field
                        v-model="modelObject.first_name"
                        label="First Name"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        v-model="modelObject.last_name"
                        label="Last Name"
                        :rules="[rules.required]"
                    ></v-text-field>
                </div>

                <v-text-field
                    v-model="modelObject.company"
                    label="Company"
                ></v-text-field>
                <v-text-field
                    v-model="modelObject.address1"
                    label="Address"
                    :rules="[rules.required]"
                ></v-text-field>
                <div class="tw-flex tw-flex-row tw-gap-2">
                    <v-text-field
                        v-model="modelObject.city"
                        label="City"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-select
                        v-model="modelObject.country_id"
                        :items="valuelist.COUNTRIES"
                        color="primary"
                        label="Country"
                        display-label="Country"
                        :rules="[rules.required]"
                        reactive
                    />
                    <v-text-field
                        v-model="modelObject.postal_code"
                        label="Postal"
                        :rules="[rules.required]"
                    ></v-text-field>
                </div>

                <template v-if="showProvinceSelect">
                    <v-select
                        v-model="modelObject.province_id"
                        :items="filteredProvinces"
                        color="primary"
                        label="Province"
                        display-label="Province"
                        :rules="[rules.required]"
                        reactive
                    />
                </template>

                <v-textarea
                    label="Notes"
                    v-model="modelObject.note"
                    outlined
                    auto-grow
                    compact
                ></v-textarea>

<!--                <v-checkbox-->
<!--                    v-model="modelObject.abbreviate_in_report"-->
<!--                    label="Use Abbreviation In Report"-->
<!--                    hide-details-->
<!--                    dense-->
<!--                    :true-value="1"-->
<!--                    :false-value="0"-->
<!--                ></v-checkbox>-->

            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="archiveProductionAddress()"
                    class="main-btn"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditProductionAddressModal",
    components: {
        DatePicker,

    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            type: Object,
            required: false
        },
        'productionId': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Number,
            required: false
        },
    },
    data() {
        return {
            dialog: this.value || false,
            production_id: this.productionId || '',
            valuelist: this.valuelists,
            mode: 'Add',
            modelObject: this.modelProp || {},
            modelDefault: {
                id: null,
                production_id: null,
                first_name: null,
                last_name: null,
                province_id: null,
                country_id: null,
                company: null,
                address1: null,
                city: null,
                postal_code: null,
                type: null,
                note: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            archiveLoading: false,
            addressTypeValueList: [
                {text: 'Production Office',         value: this.constants.PROD_ADDRESS_TYPE.TYPE_PRODUCTION_OFFICE},
                {text: 'Head Office',         value: this.constants.PROD_ADDRESS_TYPE.TYPE_HEAD_OFFICE},
                {text: 'Other',        value: this.constants.PROD_ADDRESS_TYPE.TYPE_OTHER},
            ],
        }
    },
    mounted() {
    },
    computed: {
        dialog_width() {
            return '475px'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        },
        showProvinceSelect() {
            return this.modelObject.country_id === 2 || this.modelObject.country_id === 1
        },
        filteredProvinces() {
            if (!this.valuelist || !this.valuelist.PROVINCES) {
                return []
            }
            return this.valuelist.PROVINCES.filter(province => province.country_id === this.modelObject.country_id)
        },
    },
    methods: {
        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        resetFormValidation() {
            this.$refs.editForm.reset()
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            if (this.$refs.editForm.validate()) {

                let formData = new FormData()

                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key])
                    } else {
                        formData.append(key, '')
                    }
                }

                var url = ''

                if( this.is_edit_mode ) {
                    url = route('productionaddresses.update', this.modelObject.id)
                    formData.append("updated_by",this.$page.user.id)
                    formData.append("_method", "put")
                } else {
                    formData.append("production_id", this.production_id)
                    formData.append("updated_by",this.$page.user.id)
                    url = route('productionaddresses.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.$emit('successful-address-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })

            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },

        async archiveProductionAddress()
        {
            if (await this.$root.confirm.open(`Delete Production Address`, `You are about to delete ${this.modelObject.address1}`)) {

                let method = 'delete'
                let url = route('productionaddresses.destroy', this.modelObject.id)

                axios({
                    method: method,
                    url: url,
                    data: this.modelObject,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Production address has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-address-save')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        }
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.resetFormValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
    },
}
</script>
<style scoped>
</style>
